import React, { useEffect, useState } from 'react';
import axios from 'axios';

export default function DatasetSelector({ selected, onSelect }) {
  const [datasets, setDatasets] = useState([]);
  const [loading, setLoading]   = useState(true);

  useEffect(() => {
    axios.get('/api/datasets')
      .then(r => setDatasets(r.data))
      .catch(console.error)
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <div style={{ padding: 20, color: 'var(--muted)', fontSize: 12 }}>Loading datasets…</div>;
  if (!datasets.length) return (
    <div style={{ padding: 24 }} className="card">
      <p style={{ color: 'var(--muted)', fontSize: 12 }}>No datasets uploaded yet.</p>
      <p style={{ color: 'var(--muted)', fontSize: 11, marginTop: 6 }}>Ask an admin to upload a JSON file.</p>
    </div>
  );

  return (
    <div>
      <h2 style={{ fontFamily: 'Syne, sans-serif', fontSize: 14, fontWeight: 700, marginBottom: 16, letterSpacing: '0.05em' }}>
        Choose a Dataset
      </h2>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(240px,1fr))', gap: 12 }}>
        {datasets.map(ds => (
          <button key={ds._id} onClick={() => onSelect(ds)}
            style={{
              background: selected?._id === ds._id ? 'rgba(56,189,248,0.08)' : 'var(--surface2)',
              border: `1px solid ${selected?._id === ds._id ? 'var(--accent)' : 'var(--border)'}`,
              borderRadius: 10, padding: '14px 16px', cursor: 'pointer', textAlign: 'left',
              transition: 'all 0.15s', color: 'var(--text)', fontFamily: 'JetBrains Mono, monospace',
            }}>
            <div style={{ fontFamily: 'Syne, sans-serif', fontSize: 13, fontWeight: 700, color: selected?._id === ds._id ? 'var(--accent)' : 'var(--text)', marginBottom: 6 }}>
              {ds.name}
            </div>
            <div style={{ fontSize: 10, color: 'var(--muted)' }}>{ds.originalName}</div>
            <div style={{ fontSize: 9, color: 'var(--muted)', marginTop: 4 }}>
              {new Date(ds.createdAt).toLocaleDateString()}
            </div>
          </button>
        ))}
      </div>
    </div>
  );
}
